import { entity } from '@talisdev/jsonapi-transformers';

import { HierarchyNode } from './hierarchy-node';

@entity({ type: 'nodes' })
export class Node extends HierarchyNode {
  get htmlPageUrl(): string {
    return this.node_type ? getNodeUrl(this) : undefined;
  }

  get normalisedType(): string {
    return getNormalisedTypeFromNode(this);
  }
}

/**
 * Gets the (relative) webpage URL for a node.
 *
 * @param {Node} node - The node whose URL is being requested
 * @returns {string} - The webpage URL of the node, or the root app URL
 */
export function getNodeUrl(node: Node) {
  const normalisedId = node.id.toLowerCase();
  const normalisedType = getNormalisedTypeFromNode(node);
  if (!normalisedType || normalisedType === 'institutions') {
    return '/';
  }
  return `/${normalisedType}/${normalisedId}`;
}

/**
 * Gets the normalised type for a node, according to its node_type.
 *
 * @param {Node} node - The node whose type is being requested
 * @returns {string|null} A normalised type for the node - lowercased and pluralised
 */
export function getNormalisedTypeFromNode(node: Node): string | null {
  if (!node.node_type) {
    return null;
  }

  const singularType = node.node_type.toLowerCase();
  if (singularType === 'faculty') {
    return 'faculties';
  }
  return `${singularType}s`;
}
